import { render, staticRenderFns } from "./video-action.vue?vue&type=template&id=4730fd94&scoped=true&"
import script from "./video-action.vue?vue&type=script&lang=ts&"
export * from "./video-action.vue?vue&type=script&lang=ts&"
import style0 from "./video-action.vue?vue&type=style&index=0&id=4730fd94&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4730fd94",
  null
  
)

export default component.exports